import {
  IconCar,
  IconFileText,
  IconPackage,
  IconTruck,
  IconUser,
} from "@tabler/icons-react";

const InventoryCreatedCard = ({ props, onClick }) => {
  const {
    name,
    remarks,
    productList,
    deliveryPerson,
    licensePlateNumber,
    warehouseStaff = "",
    createdAt,
    id,
    documentId,
  } = props || {};

  const formattedDate = createdAt
    ? (() => {
        const date = new Date(createdAt);
        return `${date.getFullYear()}/${String(date.getMonth() + 1).padStart(2, "0")}/${String(date.getDate()).padStart(2, "0")}`;
      })()
    : "";

  return (
    <div
      className="cursor-pointer rounded-xl border border-gray-200 bg-white p-5 shadow-sm transition-shadow hover:shadow-md"
      onClick={onClick}
    >
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50 text-blue-600">
          <IconPackage size={20} />
        </div>
        <div
          className="truncate text-lg font-semibold"
          style={{ color: "#6F6F6F" }}
        >
          {name || "—"}
        </div>
      </div>
      <div className="mt-4 space-y-2 text-sm text-gray-600">
        {deliveryPerson ? (
          <div className="flex items-center gap-2">
            <IconTruck size={15} className="text-gray-400" />
            <span className="truncate">{deliveryPerson}</span>
          </div>
        ) : null}
        {licensePlateNumber ? (
          <div className="flex items-center gap-2">
            <IconCar size={15} className="text-gray-400" />
            <span className="truncate">{licensePlateNumber}</span>
          </div>
        ) : null}
        {warehouseStaff?.name ? (
          <div className="flex items-center gap-2">
            <IconUser size={15} className="text-gray-400" />
            <span className="truncate">{warehouseStaff.name}</span>
          </div>
        ) : null}
        {remarks ? (
          <div className="flex items-center gap-2">
            <IconFileText size={15} className="text-gray-400" />
            <span className="truncate">{remarks}</span>
          </div>
        ) : null}
        {formattedDate ? (
          <div className="text-xs text-gray-400">{formattedDate}</div>
        ) : null}
      </div>
    </div>
  );
};

export default InventoryCreatedCard;
